import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-page-start',
    templateUrl: './page-start.component.html',
    styleUrls: ['./page-start.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageStartComponent {

}
